import {DriverStatusEnum} from '@/services/api-clients';

export function driverStatusTagColorFilter(status: DriverStatusEnum): string[] {
  switch (status) {
    case DriverStatusEnum.Active: return ['green', 'green--text'];
    case DriverStatusEnum.Warning: return ['orange', 'orange--text'];
    case DriverStatusEnum.New: return ['blue', 'blue--text'];
    case DriverStatusEnum.Problem: return ['purple', 'purple--text'];
    case DriverStatusEnum.Inactive: return ['grey', 'grey--text'];
    case DriverStatusEnum.WaitingForActivation: return ['teal', 'teal--text'];
    case DriverStatusEnum.NoSettlementsInLast2Weeks: return ['brown', 'brown--text'];
    case DriverStatusEnum.Bailiff: return ['red', 'red--text'];
    case DriverStatusEnum.Debtor: return ['red', 'red--text'];
    case DriverStatusEnum.PaymentSuspension: return ['orange darken-4', 'orange--text text--darken-4'];
    case DriverStatusEnum.Fraud: return ['deep-orange accent-4', 'deep-orange--text text--accent-4'];
    case DriverStatusEnum.OfficeVisitRequired: return ['warning', 'warning--text'];
    case DriverStatusEnum.Duplicate: return ['warning', 'warning--text'];
    case DriverStatusEnum.FilesMissingAfterUserRegistration: return ['warning', 'warning--text'];
    case DriverStatusEnum.HasMobileApplication: return ['indigo', 'indigo--text'];
  }
}
